import React, { Component } from "react";
import PrivateRoute from "./auth/PrivateRoute";
import { Route, Routes } from "react-router-dom";
import Signin from "./auth/Signin";
import LivroFormMenu from "./shared/components/LateralMenu/Content/LivroFormMenu";
import AlunoTurmaFormMenu from "./shared/components/LateralMenu/Content/AlunoTurmaFormMenu";
import NotFoundMenu from "./shared/components/LateralMenu/Content/NotFoundMenu";
import LateralMenuContent from "./shared/components/LateralMenu/LateralMenuContent";
import PresencaCapituloPlanejamentoTodos from "./components/PresencaCapitulo/PresencaCapituloPlanejamentoTodos";
import ObservacaoTurmaContainer from "./components/ObservacaoTurma/ObservacaoTurmaContainer";
import ObservacaoAlunoContainer from "./components/ObservacaoAluno/ObservacaoAlunoContainer";
import NotaBimestreContainer from "./components/NotaBimestre/NotaBimestreContainer";
import RelatorioContainer from "./components/Relatorio/RelatorioContainer";
import RelatorioAlunoContainer from "./components/Relatorio/Aluno/RelatorioAlunoContainer";
import RelatorioBoletimItinerarioWeb from "./components/Relatorio/Web/Boletim/RelatorioBoletimItinerarioWeb";
import RelatorioAtaFinalWeb from "./components/Relatorio/Web/RelatorioAtaFinalWeb";
import RelatorioAtaFinalTurmaWeb from "./components/Relatorio/Web/AtaFinalTurma/RelatorioAtaFinalTurmaWeb";
import RelatorioRendimentoEscolarWeb from "./components/Relatorio/Web/RelatorioRendimentoEscolarWeb";
import AtividadeAlunoContainer from "./components/AtividadeAluno/AtividadeAlunoContainer";
import AtividadeContainer from "./components/Atividade/AtividadeContainer";
import AusenciaCompensadaContainer from "./components/AlunoFrequencia/AusenciaCompensada/AusenciaCompensadaContainer";
import PresencaAlunoContainer from "./components/PresencaAluno/PresencaAlunoContainer";
import PresencaContainer from "./components/Presenca/PresencaContainer";
import DisciplinaContainer from "./components/Disciplina/DisciplinaContainer";
import AlunoTurmaContainer from "./components/AlunoTurma/AlunoTurmaContainer";
import PlanejamentoConsultaQuant from "./components/Planejamento/PlanejamentoConsultaQuant";
import PlanejamentoContainer from "./components/Planejamento/PlanejamentoContainer";
import LivroDisciplinaTurmaForm from "./components/TDP/LivroDisciplinaTurmaForm";
import ProfessorDisciplinaTurmaForm from "./components/TDP/ProfessorDisciplinaTurmaForm";
import DisciplinaTurmaContainer from "./components/TDP/DisciplinaTurmaContainer";
import LivroContainer from "./components/Livro/LivroContainer";
import ConfiguracaoContainer from "./components/Configuracao/ConfiguracaoContainer";
import BimestreForm from "./components/Bimestre/BimestreForm";
import AlunoContainer from "./components/Aluno/AlunoContainer";
import Home from "./components/Home";
import UsuarioContainer from "./components/Usuario/UsuarioContainer";
import PAAlunoContainer from "./components/PresencaAluno/Aluno/PAAlunoContainer";
import OAAlunoContainer from "./components/ObservacaoAluno/Aluno/OAAlunoContainer";
import AAAlunoContainer from "./components/AtividadeAluno/Aluno/AAAlunoContainer";
import NBAlunoContainer from "./components/NotaBimestre/Aluno/NBAlunoContainer";
import ComunicadoContainer from "./components/Comunicado/Comunicado/ComunicadoContainer";
import ComunicadoCategoriaContainer from "./components/Comunicado/ComunicadoCategoria/ComunicadoCategoriaContainer";
import ComunicadoUsuarioContainer from "./components/Comunicado/ComunicadoUsuario/ComunicadoUsuarioContainer";
import UsuarioImport from "./components/Usuario/UsuarioImport";
import Curso from "./components/Curso/CursoContainer";
import Serie from "./components/Serie/SerieContainer";
import Turma from "./components/Turma/TurmaContainer";
import AcompanhamentoContainer from "./components/Acompanhamento/AcompanhamentoContainer";

import RespostaContainer from "./components/Capitulo/Conteudo/Resposta/RespostaContainer";
import CapituloTable from "./components/Capitulo/CapituloTable";
import CapituloForm from "./components/Capitulo/CapituloForm";
import AlunoLivroContainer from "./components/AlunoLivro/AlunoLivroContainer";
import RequestResetPassword from "./auth/RequestResetPassword";
import ResetPassword from "./auth/ResetPassword";
import MensagemTable from "./components/Mensagem/MensagemTable/MensagemTable";
import SalaMensagem from "./components/Mensagem/SalaMensagem/SalaMensagem";
import GroupForm from "./components/Mensagem/Group/GroupForm";
import GroupListParticipants from "./components/Mensagem/SalaParticipante/GroupListParticipants";
import EventoContainer from "./components/Evento/Evento/EventoContainer";
import EventoUsuarioContainer from "./components/Evento/EventoUsuario/EventoUsuarioContainer";
import AAAlunoForm from "./components/AtividadeAluno/Aluno/AAAlunoForm";
import LateralMenuSkeletonLivro from "./shared/components/LateralMenu/LateralMenuSkeletonLivro";
import LateralMenuSkeletonAvaliacaoSecao from "./shared/components/LateralMenu/LateralMenuSkeletonAvaliacaoSecao";
import AvaliacaoContainer from "./components/Avaliacao/AvaliacaoContainer";
import AvaliacaoConteudoContainer from "./components/Avaliacao/Conteudo/AvaliacaoConteudoContainer";
import AvaliacaoResultadoContainer from "./components/Avaliacao/Aluno/AvaliacaoResultadoContainer";
import AvaliacaoAlunoContainer from "./components/Avaliacao/Aluno/AvaliacaoAlunoContainer";
import LivroInstituicaoContainer from "./components/Livro/Instituicao/LivroInstituicaoContainer";
import LivroAutorContainer from "./components/Livro/Autor/LivroAutorContainer";
import LivroFormContainer from "./components/Livro/LivroFormContainer";
import CronogramaContainer from "./components/Cronograma/CronogramaContainer";
import CronogramaAulaContainer from "./components/Cronograma/Aula/CronogramaAulaContainer";
import ConteudoTable from "./components/Capitulo/Conteudo/ConteudoTable";
import AlunoLivroAddContainer from "./components/AlunoLivro/Add/AlunoLivroAddContainer";
import FinanceiroInstituicaoContainer from "./components/Financeiro/Instituicao/FinanceiroInstituicaoContainer";
import HistoricoLancamentoContainer from "./components/Financeiro/HistoricoLancamento/HistoricoLancamentoContainer";
import AlunoSemResponsavelFinanceiro from "./components/Relatorio/Web/PorAnoLetivo/AlunoSemResponsavelFinanceiro";
import ResponsavelFinanceiroSemCelular from "./components/Relatorio/Web/PorAnoLetivo/ResponsavelFinanceiroSemCelular";
import FinanceiroResponsavelContainer from "./components/Financeiro/Aluno/FinanceiroResponsavelContainer";
import UsuarioResponsavelFinanceiroNuncaAcessou from "./components/Relatorio/Web/PorAnoLetivo/UsuarioResponsavelFinanceiroNuncaAcessou";
import SmsReminderContainer from "./components/Financeiro/SmsReminder/SmsReminderContainer";
import MensagemFindContainer from "./components/Mensagem/MensagemFindContainer";
import ImageUriFullScreen from "./components/UI/ImageUriFullScreen";
import PrivatePolicyApp from "./shared/components/PrivatePolicy/PrivatePolicyApp";
import IntegralMenu from "./components/Integral/IntegralMenu";
import IntegralPresencaContainer from "./components/Integral/Presenca/IntegralPresencaContainer";
import IntegralProfessorContainer from "./components/Integral/Professor/IntegralProfessorContainer";
import IntegralPresencaAlunoContainer from "./components/Integral/PresencaAluno/Aluno/IntegralPresencaAlunoContainer";

import CardapioContainer from "./components/Cardapio/CardapioContainer";
import CardapioUsuarioContainer from "./components/Cardapio/Usuario/CardapioUsuarioContainer";
import IntegralRotinaContainer from "./components/Integral/Rotina/IntegralRotinaContainer";
import IntegralRotinalAlunoContainer from "./components/Integral/Rotina/Aluno/IntegralRotinaAlunoContainer";
import SmsPendenciaContainer from "./components/Financeiro/SmsPendencia/SmsPendenciaContainer";
import MuralContainer from "./components/Mural/MuralContainer";
import MuralFotoUsuarioContainer from "./components/Mural/MuralFoto/MuralFotoUsuarioContainer";
import AlunoFotoContainer from "./components/AlunoFoto/AlunoFotoContainer";
import AlunoFotoInsert from "./components/AlunoFoto/AlunoFotoInsert";
import BimestreContainerMenu from "./components/Bimestre/BimestreContainerMenu";
import CronogramaQuantAulaDia from "./components/Cronograma/CronogramaQuantAulaDia/CronogramaQuantAulaDiaContainer";
import CronogramaQuantAulaBimestreContainer from "./components/Cronograma/CronogramaQuantAulaBimestre/CronogramaQuantAulaBimestreContainer";
import PublicRoute from "./auth/PublicRoute";
import UsuarioFormSenha from "./components/Usuario/UsuarioFormSenha";
import LivroProfessorContainer from "./components/Livro/Professor/LivroProfessorContainer";
import UsuarioDescricaoAutorForm from "./components/Usuario/UsuarioDescricaoAutorForm";
import ConferirComPresencaContainer from "./components/Cronograma/CronogramaQuantAulaDia/Conferir/ConferirComPresencaContainer";
import CronogramaCurrentProfessorContainer from "./components/Cronograma/CronogramaProfessor/CronogramaCurrentProfessor/CronogramaCurrentProfessorContainer";
import RelatorioFrequenciaWeb from "./components/Relatorio/Web/Frequencia/RelatorioFrequenciaWeb";
import RelatorioConfereRegAulaFaltaWeb from "./components/Relatorio/Web/RelatorioConfereRegAulaFaltaWeb";
import ComunicadoBannerContainer from "./components/Comunicado/ComunicadoBanner/ComunicadoBannerContainer";
import LocalContainer from "./components/Local/LocalContainer";
import MensagemFindAllContainer from "./components/Mensagem/MensagemFindAllContainer";
import RltFrequenciaPorAlunoMesAnoLetivo from "./components/Relatorio/Web/FrequenciaPorAlunoMesAnoLetivo/RltFrequenciaPorAlunoMesAnoLetivo";
import CatracaRegistroUsuarioContainer from "./components/CatracaRegistro/CatracaRegistroUsuario/CatracaRegistroUsuarioContainer";
import PresencaLoteContainer from "./components/Presenca/PresencaLote/PresencaLoteContainer";
import PresencaMenu from "./components/Presenca/PresencaMenu";
import PresencaTurmaContainer from "./components/Presenca/PresencaTurma/PresencaTurmaContainer";
import PresencaDisciplinaContainer from "./components/Presenca/PresencaDisciplina/PresencaDisciplinaContainer";
import CatracaRegistroContainer from "./components/CatracaRegistro/CatracaRegistroContainer";
import PresencaUsuarioContainer from "./components/Presenca/PresencaUsuario/PresencaUsuarioContainer";
import CatracaRegistroMenu from "./components/CatracaRegistro/CatracaRegistroMenu";
import CatracaRegistroCheckContainer from "./components/CatracaRegistro/CatracaRegistroCheck/CatracaRegistroCheckContainer";
import AlunoFrequenciaLoteContainer from "./components/AlunoFrequencia/AlunoFrequenciaLote/AlunoFrequenciaLoteContainer";
import ObservacaoAlunoContainerV2 from "./components/ObservacaoAluno/v2/ObservacaoAlunoContainerV2";
import ObservacaoAlunoMenu from "./components/ObservacaoAluno/ObservacaoAlunoMenu";
import ObservacaoAlunoLoteContainer from "./components/ObservacaoAluno/Lote/ObservacaoAlunoLoteContainer";
import PresencaPorDataContainer from "./components/Presenca/PresencaPorData/PresencaPorDataContainer";
import InstituicaoContainer from "./components/Instituicao/InstituicaoConainer";
import VotacaoContainer from "./components/Votacao/VotacaoContainer";
import VotacaoUsuarioContainer from "./components/VotacaoUsuario/VotacaoUsuarioContainer";
import ComunicadoMenu from "./components/Comunicado/Comunicado/ComunicadoMenu";
import LancamentoPagamentoPorCreditoContainer from "./components/Financeiro/Aluno/LancamentoPagamentoPorCreditoContainer";
import LancamentoPagamentoPorCreditoRetornoContainer from "./components/Financeiro/Aluno/LancamentoPagamentoPorCreditoRetornoContainer";
import InstituicaoImport from "./components/Instituicao/InstituicaoImport";
import CantinaUsuarioContainer from "./components/Cantina/CantinaUsuarioContainer";
import CantinaCreditoSolicitacaoContainer from "./components/Cantina/CantinaCreditoSolicitacao/CantinaCreditoSolicitacaoContainer";
import UsuarioCartaoCreditoForm from "./components/UsuarioCartaoCredito/UsuarioCartaoCreditoForm";
import CustomMuiTableUsage from "./components/UI/CustomMuiTableUsage";
import InsereCreditoContainer from "./components/Cantina/InsereCreditoContainer";
import UsuarioResponsavelSemCpfCnpj from "./components/Relatorio/Web/PorAnoLetivo/UsuarioResponsavelSemCpfCnpj";
import CatracaRegistroListaContainer from "./components/CatracaRegistro/CatracaRegistroLista/CatracaRegistroListaContainer";
import CatracaRegistroContadorContainer from "./components/CatracaRegistro/CatracaRegistroContador/CatracaRegistroContadorContainer";
import RelatorioAlunoNotaBimestreTipoWeb from "./components/Relatorio/Web/AlunoNotaBimestreTipo/RelatorioAlunoNotaBimestreTipoWeb";
import RelatorioAtaFinalTurmaWebV2 from "./components/Relatorio/Web/AtaFinalTurma/RelatorioAtaFinalTurmaWebV2";

class MenuRouter extends Component {
  render() {
    return (
      <div>
        <Routes>
          <Route exact path="/" element={<Signin />} />
          <Route
            exact
            path="/private-policy-app"
            element={<PrivatePolicyApp />}
          />
          <Route exact path="/signin" element={<Signin />} />
          <Route
            exact
            path="/request-reset-password"
            element={<RequestResetPassword />}
          />
          <Route
            path="/reset-password/:codResetPassword"
            element={<ResetPassword />}
          />
          <Route
            path="/conteudos/:codLivro"
            element={
              <PublicRoute
                component={LateralMenuSkeletonLivro}
                child={ConteudoTable}
              />
            }
          />
          <Route
            path="/conteudos/:codLivro/:codCapitulo"
            element={
              <PublicRoute
                component={LateralMenuSkeletonLivro}
                child={ConteudoTable}
              />
            }
          />
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute component={LateralMenuContent} child={Home} />
            }
          />
          <Route
            exact
            path="/alunos"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/bimestre"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={BimestreContainerMenu}
              />
            }
          />
          <Route
            exact
            path="/bimestre-form"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={BimestreForm}
              />
            }
          />
          <Route
            exact
            path="/turma"
            element={
              <PrivateRoute component={LateralMenuContent} child={Turma} />
            }
          />
          <Route
            exact
            path="/usuarios"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/usuario-senha"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioFormSenha}
              />
            }
          />
          <Route
            exact
            path="/configuracao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ConfiguracaoContainer}
              />
            }
          />
          <Route
            exact
            path="/livros"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroContainer}
              />
            }
          />
          <Route
            exact
            path="/livro-instituicao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroInstituicaoContainer}
              />
            }
          />
          <Route
            exact
            path="/livro-professor"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroProfessorContainer}
              />
            }
          />
          <Route
            exact
            path="/livro-form"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroFormContainer}
              />
            }
          />
          <Route
            exact
            path="/livro"
            element={<PrivateRoute component={LivroFormMenu} />}
          />
          <Route
            exact
            path="/livro-capitulos"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CapituloTable}
              />
            }
          />
          <Route
            exact
            path="/livro-capitulo"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CapituloForm}
              />
            }
          />
          <Route
            exact
            path="/conteudos"
            element={
              <PrivateRoute
                component={LateralMenuSkeletonLivro}
                child={ConteudoTable}
              />
            }
          />
          <Route
            exact
            path="/disciplina-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={DisciplinaTurmaContainer}
              />
            }
          />
          <Route
            exact
            path="/professor-disciplina-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ProfessorDisciplinaTurmaForm}
              />
            }
          />
          <Route
            exact
            path="/livro-disciplina-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroDisciplinaTurmaForm}
              />
            }
          />
          <Route
            exact
            path="/planejamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PlanejamentoContainer}
              />
            }
          />
          <Route
            exact
            path="/planejamento-consulta-quant"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PlanejamentoConsultaQuant}
              />
            }
          />
          <Route
            exact
            path="/aluno-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoTurmaContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno-turma-form"
            element={<PrivateRoute component={AlunoTurmaFormMenu} />}
          />
          <Route
            exact
            path="/disciplina"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={DisciplinaContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-menu"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaMenu}
              />
            }
          />
          <Route
            exact
            path="/presenca-por-disciplina"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaDisciplinaContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-por-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaTurmaContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-por-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaUsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-por-data"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaPorDataContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/atividade"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AtividadeContainer}
              />
            }
          />
          <Route
            exact
            path="/ausencia-compensada"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AusenciaCompensadaContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno-frequencia-lote"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoFrequenciaLoteContainer}
              />
            }
          />
          <Route
            exact
            path="/atividade-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AtividadeAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/relatorio"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioContainer}
              />
            }
          />
          <Route
            exact
            path="/relatorio-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/relatorio-boletim-web"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioBoletimItinerarioWeb}
              />
            }
          />
          <Route
            exact
            path="//relatorio-web-aluno-nota-bimestre-tipo"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioAlunoNotaBimestreTipoWeb}
              />
            }
          />
          <Route
            exact
            path="/relatorio-ata-final-web"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioAtaFinalWeb}
              />
            }
          />
          <Route
            exact
            path="/relatorio-ata-final-turma-web"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioAtaFinalTurmaWeb}
              />
            }
          />
          <Route
            exact
            path="/relatorio-ata-final-turma-web-v2"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioAtaFinalTurmaWebV2}
              />
            }
          />
          <Route
            exact
            path="/relatorio-rendimento-escolar-web"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioRendimentoEscolarWeb}
              />
            }
          />
          <Route
            exact
            path="/nota-bimestre"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={NotaBimestreContainer}
              />
            }
          />
          <Route
            exact
            path="/observacao-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ObservacaoAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/observacao-aluno-v2"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ObservacaoAlunoContainerV2}
              />
            }
          />
          <Route
            exact
            path="/observacao-aluno-menu"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ObservacaoAlunoMenu}
              />
            }
          />
          <Route
            exact
            path="/observacao-aluno-lote"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ObservacaoAlunoLoteContainer}
              />
            }
          />
          <Route
            exact
            path="/observacao-turma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ObservacaoTurmaContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-capitulo-planejamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaCapituloPlanejamentoTodos}
              />
            }
          />

          <Route
            exact
            path="/aluno/presenca-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PAAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/observacao-user"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={OAAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno/atividade-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AAAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno/nota-bimestre-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={NBAlunoContainer}
              />
            }
          />
          <Route
            exact
            path="/comunicado"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ComunicadoContainer}
              />
            }
          />
          <Route
            exact
            path="/comunicado-menu"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ComunicadoMenu}
              />
            }
          />
          <Route
            exact
            path="/comunicado-categoria"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ComunicadoCategoriaContainer}
              />
            }
          />
          <Route
            exact
            path="/comunicado-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ComunicadoUsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/usuario-import"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioImport}
              />
            }
          />
          <Route
            exact
            path="/instituicao-import"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={InstituicaoImport}
              />
            }
          />
          <Route
            exact
            path="/curso"
            element={
              <PrivateRoute component={LateralMenuContent} child={Curso} />
            }
          />
          <Route
            exact
            path="/serie"
            element={
              <PrivateRoute component={LateralMenuContent} child={Serie} />
            }
          />
          <Route
            exact
            path="/acompanhamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AcompanhamentoContainer}
              />
            }
          />
          <Route
            exact
            path="/correcao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RespostaContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno-livro"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoLivroContainer}
              />
            }
          />

          <Route
            exact
            path="/mensagem"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={MensagemTable}
              />
            }
          />
          <Route
            exact
            path="/sala-mensagem"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={SalaMensagem}
              />
            }
          />
          <Route
            exact
            path="/group-form"
            element={
              <PrivateRoute component={LateralMenuContent} child={GroupForm} />
            }
          />
          <Route
            exact
            path="/mensagem-find"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={MensagemFindContainer}
              />
            }
          />
          <Route
            exact
            path="/mensagem-find-all"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={MensagemFindAllContainer}
              />
            }
          />
          <Route
            exact
            path="/group-list-participants"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={GroupListParticipants}
              />
            }
          />

          <Route
            exact
            path="/evento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={EventoContainer}
              />
            }
          />
          <Route
            exact
            path="/evento-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={EventoUsuarioContainer}
              />
            }
          />

          <Route
            exact
            path="/atividade-aluno-anexo"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AAAlunoForm}
              />
            }
          />

          <Route
            exact
            path="/avaliacao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AvaliacaoContainer}
              />
            }
          />
          <Route
            exact
            path="/avaliacao-secao"
            element={
              <PrivateRoute
                component={LateralMenuSkeletonAvaliacaoSecao}
                child={AvaliacaoConteudoContainer}
              />
            }
          />
          <Route
            exact
            path="/avaliacao-resultado"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AvaliacaoResultadoContainer}
              />
            }
          />
          <Route
            exact
            path="/avaliacao-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AvaliacaoAlunoContainer}
              />
            }
          />

          <Route
            exact
            path="/livro-autor"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LivroAutorContainer}
              />
            }
          />
          <Route
            exact
            path="/cronograma"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CronogramaContainer}
              />
            }
          />
          <Route
            exact
            path="/cronograma-professor"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CronogramaCurrentProfessorContainer}
              />
            }
          />
          <Route
            exact
            path="/cronograma-aula"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CronogramaAulaContainer}
              />
            }
          />
          <Route
            exact
            path="/livro-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoLivroAddContainer}
              />
            }
          />

          <Route
            exact
            path="/financeiro-instituicao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={FinanceiroInstituicaoContainer}
              />
            }
          />
          <Route
            exact
            path="/financeiro-responsavel"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={FinanceiroResponsavelContainer}
              />
            }
          />
          <Route
            exact
            path="/historico-lancamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={HistoricoLancamentoContainer}
              />
            }
          />
          <Route
            exact
            path="/sms-reminder-lancamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={SmsReminderContainer}
              />
            }
          />
          <Route
            exact
            path="/sms-pendencia"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={SmsPendenciaContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno-sem-responsavel-financeiro"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoSemResponsavelFinanceiro}
              />
            }
          />
          <Route
            exact
            path="/responsavel-financeiro-sem-celular"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ResponsavelFinanceiroSemCelular}
              />
            }
          />
          <Route
            exact
            path="/responsavel-financeiro-nunca-acessou-sistema"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioResponsavelFinanceiroNuncaAcessou}
              />
            }
          />
          <Route
            exact
            path="/responsavel-sem-cpf-cnpj"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioResponsavelSemCpfCnpj}
              />
            }
          />
          <Route
            exact
            path="/image-full-screen"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ImageUriFullScreen}
              />
            }
          />
          <Route
            exact
            path="/integral"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralMenu}
              />
            }
          />
          <Route
            exact
            path="/integral-presenca"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralPresencaContainer}
              />
            }
          />
          <Route
            exact
            path="/integral-professor"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralProfessorContainer}
              />
            }
          />
          <Route
            exact
            path="/integral-presenca-aluno"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralPresencaAlunoContainer}
              />
            }
          />

          <Route
            exact
            path="/cardapio"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CardapioContainer}
              />
            }
          />
          <Route
            exact
            path="/cardapio-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CardapioUsuarioContainer}
              />
            }
          />

          <Route
            exact
            path="/rotina"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralRotinaContainer}
              />
            }
          />
          <Route
            exact
            path="/rotina-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={IntegralRotinalAlunoContainer}
              />
            }
          />

          <Route
            exact
            path="/mural"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={MuralContainer}
              />
            }
          />
          <Route
            exact
            path="/mural-foto-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={MuralFotoUsuarioContainer}
              />
            }
          />

          <Route
            exact
            path="/aluno-foto"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoFotoContainer}
              />
            }
          />
          <Route
            exact
            path="/aluno-foto-insert"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={AlunoFotoInsert}
              />
            }
          />

          <Route
            exact
            path="/cronograma-quant-aula-bimestre"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CronogramaQuantAulaBimestreContainer}
              />
            }
          />
          <Route
            exact
            path="/cronograma-quant-aula-dia"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CronogramaQuantAulaDia}
              />
            }
          />
          <Route
            exact
            path="/descricao-autor"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioDescricaoAutorForm}
              />
            }
          />
          <Route
            exact
            path="/conferir-cronograma-presenca"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ConferirComPresencaContainer}
              />
            }
          />
          <Route
            exact
            path="/relatorio-frequencia-web"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioFrequenciaWeb}
              />
            }
          />
          <Route
            exact
            path="/confere-registro-aula-falta"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RelatorioConfereRegAulaFaltaWeb}
              />
            }
          />
          <Route
            exact
            path="/comunicado-banner"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={ComunicadoBannerContainer}
              />
            }
          />
          <Route
            exact
            path="/local"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LocalContainer}
              />
            }
          />
          <Route
            exact
            path="/relatorio-frequencia-por-aluno-mes-ano-letivo"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={RltFrequenciaPorAlunoMesAnoLetivo}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso-menu"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroMenu}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso-contador"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroContadorContainer}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso-check"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroCheckContainer}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso-lista"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroListaContainer}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroContainer}
              />
            }
          />
          <Route
            exact
            path="/monitor-acesso-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CatracaRegistroUsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/presenca-lote"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={PresencaLoteContainer}
              />
            }
          />
          <Route
            exact
            path="/instituicao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={InstituicaoContainer}
              />
            }
          />
          <Route
            exact
            path="/votacao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={VotacaoContainer}
              />
            }
          />
          <Route
            exact
            path="/votacao-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={VotacaoUsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/lancamento/pagamento-por-cartao-credito/:codLancamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LancamentoPagamentoPorCreditoContainer}
              />
            }
          />
          <Route
            exact
            path="/lancamento/pagamento-por-cartao-credito-retorno/:codLancamento"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={LancamentoPagamentoPorCreditoRetornoContainer}
              />
            }
          />
          <Route
            exact
            path="/cantina-usuario"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CantinaUsuarioContainer}
              />
            }
          />
          <Route
            exact
            path="/cantina/insere-credito"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={InsereCreditoContainer}
              />
            }
          />
          <Route
            exact
            path="/cantina-credito-solicitacao"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={CantinaCreditoSolicitacaoContainer}
              />
            }
          />
          <Route
            exact
            path="/insere-novo-cartao-credito"
            element={
              <PrivateRoute
                component={LateralMenuContent}
                child={UsuarioCartaoCreditoForm}
              />
            }
          />
          <Route
            exact
            path="/mui-table-custom"
            element={<CustomMuiTableUsage />}
          />
          <Route element={<NotFoundMenu />} />
        </Routes>
      </div>
    );
  }
}

export default MenuRouter;
